import mutationsTypes from '@/vuex/arquivos-assinados/mutations-types.js'

const types = {
  ...mutationsTypes,
  BUSCAR_ARQUIVOS_ASSINADOS: 'BUSCAR_ARQUIVOS_ASSINADOS',
  EXCLUIR_ARQUIVO_ASSINADO: 'EXCLUIR_ARQUIVO_ASSINADO',
  EXCLUIR_ARQUIVO_ASSINADO_EM_BLOCO: 'EXCLUIR_ARQUIVO_ASSINADO_EM_BLOCO',
  BUSCAR_TIPOS_ASSINATURA: 'BUSCAR_TIPOS_ASSINATURA',
  INSERIR_ARQUIVO_ASSINADO: 'INSERIR_ARQUIVO_ASSINADO',
  GET_ARQUIVO_ASSINADO_BLOB_URL: 'GET_ARQUIVO_ASSINADO_BLOB_URL',
  SET_ARQUIVO_ASSINADO_BLOB_URL: 'SET_ARQUIVO_ASSINADO_BLOB_URL',
  SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG: 'SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG',
  HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG: 'HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/arquivos-assinados/actions-types.js